import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import Icon from 'src/common/components/IconDS22';
import type { Breadcrumb } from 'src/common/types/api/v4/boats/search';
import type { Reviews } from 'src/common/types/api/v4/search/v1/landing';
import { REVIEWS_ANCHOR } from 'src/search/constants';
import Typography from 'src/common/components/Typography';
import DlpBreadcrumbs from 'src/search/components/DlpBreadcrumbs';
import styles from './DlpPageStats.module.scss';

export type DlpPageStatsProps = {
  breadcrumbs?: Breadcrumb[] | null;
}
& Pick<Reviews, 'average' | 'total'>;

const DlpPageStats: FC<DlpPageStatsProps> = ({
  average,
  total,
  breadcrumbs,
}) => {
  const [t] = useTranslation('discovery-landing-pages');
  const showBreadcrumbs = breadcrumbs && breadcrumbs?.length > 0;
  const showReviews = total ? total > 0 : false;

  return (
    <div className={styles.root}>
      {showReviews && (
        <div className={styles.iconAndReviews}>
          <Icon
            id="star-filled"
            size="s"
            className={styles.icon}
          />
          <a href={`#${REVIEWS_ANCHOR}`}>
            <Typography
              type="p"
              size="body-l"
            >
              {average}
              {` (${t('stats--reviews', { count: total })})`}
            </Typography>
          </a>
          <Typography
            type="p"
            size="body-l"
          >
            {' • '}
          </Typography>
        </div>
      )}
      {showBreadcrumbs && (
        <DlpBreadcrumbs
          breadcrumbs={breadcrumbs}
          separator=" - "
        />
      )}
    </div>
  );
};

export default DlpPageStats;
